import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Config } from 'ng-otp-input/lib/models/config';
import { Subscription, timer } from 'rxjs';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { VerificationContractService } from 'src/app/services/Auth/verification-contract.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { ShakeAnimationService } from 'src/app/services/shake-animation/shake-animation.service';

@Component({
  selector: 'ipm-otp-page',
  templateUrl: './otp-page.component.html',
  styleUrls: ['./otp-page.component.scss']
})
export class OtpPageComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() userInfo: any;
  @Input() type: any = "";
  @ViewChild('ngOtpInput') ngOtpInputRef:any;
  @Output() closingOtpPopup :  EventEmitter<any> =  new EventEmitter();
  @Output() onClickResendOtpEvent :  EventEmitter<any> =  new EventEmitter();
  @Input() errorMessage: string = "";
  @Input() dialogClassName: string = "";
  mobileOtp: any = "";
  otp:any;
  combinedOtp: string = '';
  isOtpVisible: boolean = false;
  isReadOnly: boolean = true;
  
  countdown: number;
  isVerificationLocked: boolean = false;
  countdownSubscription: Subscription | null = null;

  constructor(public commonService: CommonService,
    private authService: AuthService,
    private verificationContract: VerificationContractService,
    public shakeAnimation:ShakeAnimationService,
    private cdr: ChangeDetectorRef,
    public formService: FormsService) { }

  ngOnInit(): void {
    this.shakeAnimation.errorMessage = '';
  }

  ngAfterViewInit(): void {
    const waitTimer = this.userInfo?.mobileNumber?.waitTimer || this.userInfo?.waitTimer;
    if (waitTimer) {
        this.disableResendBtn(waitTimer);
    } else {
        this.disableResendBtn(60);
    }
    this.restoreCooldownStateFromStorage();
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['errorMessage']) {
        if (this.verificationContract.isOtpLockoutMessage(this.errorMessage)) {
          this.isVerificationLocked = true;
          this.clearOtpInputs();
          this.disableResendBtn();
        } else {
           const waitMatch = this.errorMessage.match(/wait (\d+) seconds/i);
           if (waitMatch && waitMatch[1]) {
              this.disableResendBtn(parseInt(waitMatch[1], 10));
              this.removeError();
              return;
           }
        }
        this.errorMessage ? this.showError() : this.removeError();
      }
  }

  ngOnDestroy(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = null;
    }
  }

  onCombinedOtpChange(value: string) {
    if (this.userInfo?.channel === 'sms') {
      this.combinedOtp = (value || '').replace(/\D/g, '');
    } else {
      this.combinedOtp = (value || '').replace(/\D/g, '').slice(0, 6);
    }
    if (this.userInfo?.type) {
      this.mobileOtp = this.combinedOtp;
    } else {
      this.otp = this.combinedOtp;
    }
  }

  closeByDeviceType() {
    this.commonService.closePopUp();
  }

  /**
   *  Verfication send this Otp
   */
  confirmVerification() {
    let className = this.dialogClassName ? this.commonService.getClassName(this.dialogClassName) : this.commonService.getClassName('ipm-otp-model');
    this.clearError(className);
    const otpCode = this.userInfo?.type
      ? (this.userInfo?.channel === 'sms' ? (this.mobileOtp || '').replace(/\D/g, '') : (this.mobileOtp || '').replace(/\D/g, '').slice(0, 6))
      : (this.otp || '').replace(/\D/g, '').slice(0, 6);

    if (this.isVerificationLocked) {
      this.showError('Please request a new OTP to continue.');
      return;
    }

    if (!otpCode) {
      this.showError(this.userInfo?.channel === 'sms' ? 'Please enter the OTP.' : 'Please enter the 6-digit OTP.');
      return;
    }

    if (this.userInfo?.channel !== 'sms' && otpCode.length !== 6) {
      this.showError('Please enter the 6-digit OTP.');
      return;
    }

    if (this.userInfo?.type) {
      let sendOtpData: any = {
        "isd":this.userInfo?.mobileNumber?.isd ,
        "number":this.userInfo?.mobileNumber?.number,
        "otp":otpCode,
        "code":otpCode
      }
      if (this.userInfo?.callingFrom) {
        sendOtpData["callingFrom"] = this.userInfo?.callingFrom;
      }
      if (this.userInfo?.clientId) {
        sendOtpData["clientId"] = this.userInfo?.clientId;
      }
      this.closingOtpPopup.emit(sendOtpData);
    } else {
      let sendData = {
        "user_id": this.userInfo?._id,
        "code": otpCode
      }
      let confirmationType = this.userInfo?.callingForm;
      confirmationType = confirmationType === 'forgotPassword' ?  ''  : confirmationType;
      this.authService.verificationCode(sendData, confirmationType).subscribe( res => {
          if (res.data &&  !this.userInfo?.type) {
            this.authService.currentUserDetails.next(res.data.user);
          }
          if (this.userInfo?.callingForm === 'guest-checkout') {
             this.commonService.showToastSuccess('Your email has been verified.');
          } else if (res.message && res.message.toLowerCase().includes('account setup')) {
             this.commonService.showToastSuccess('Your email has been verified.');
          }
          this.commonService.closingPopupWithSendData(this.userInfo?.callingForm);
      }, (error) => {
        if (this.verificationContract.isOtpLockout(error)) {
          this.isVerificationLocked = true;
          this.clearOtpInputs();
          this.disableResendBtn();
        }
        this.showError(this.verificationContract.extractErrorMessage(error))
      });
    }
  }

  /**
   * method to set countdown
   */
  disableResendBtn(seconds: number = 60) {
    this.countdown = seconds;
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = null;
    }
    this.saveCooldownStateToStorage();
    this.countdownSubscription = timer(0, 1000).subscribe(() => {
        this.countdown = this.countdown - 1;
        if (this.countdown <= 0) {
            this.countdown = 0;
            if (this.countdownSubscription) {
              this.countdownSubscription.unsubscribe();
              this.countdownSubscription = null;
            }
            this.clearCooldownStateFromStorage();
        }
    });
  }

  /**
 * Clear Error data when change  toggle
 */
  clearError(className:string) {
    this.shakeAnimation.removeClass(className);
  }

  /**
   * Resend the otp data
   */
  resendOtp() {
    this.isVerificationLocked = false;
    this.clearOtpInputs();
    this.removeError();
    if (this.userInfo?.type) {
      this.onClickResendOtpEvent.emit(true);
      // Let the parent catch the rate limit and pass it via errorMessage
    } else {
      this.authService.sendVerificationCode(this.userInfo?._id).subscribe( 
        res => {
          this.disableResendBtn();
        },
        error => {
          const msg = this.verificationContract.extractErrorMessage(error);
          const waitMatch = msg.match(/wait (\d+) seconds/i);
          
          if (this.verificationContract.isOtpLockout(error)) {
            this.isVerificationLocked = true;
            this.disableResendBtn(waitMatch && waitMatch[1] ? parseInt(waitMatch[1], 10) : 60);
            this.showError(msg);
          } else if (waitMatch && waitMatch[1]) {
            this.disableResendBtn(parseInt(waitMatch[1], 10));
            // Don't show error shake if we just start the timer
          } else {
            this.showError(msg);
          }
        }
      );
    }
  }

  showError(errorMessage: string = "") {
    let className = this.dialogClassName ? this.commonService.getClassName(this.dialogClassName) : this.commonService.getClassName('ipm-otp-model');
    this.shakeAnimation.addShakeAnimation(className);
    this.shakeAnimation.errorMessage = errorMessage ? errorMessage : this.errorMessage;
  }

  removeError() {
    let className = this.dialogClassName ? this.commonService.getClassName(this.dialogClassName) : this.commonService.getClassName('ipm-otp-model');
    this.shakeAnimation.addShakeAnimation(className, "remove");
    this.shakeAnimation.errorMessage = ""
  }

  private clearOtpInputs() {
    this.otp = '';
    this.mobileOtp = '';
    this.combinedOtp = '';
  }

  private saveCooldownStateToStorage(): void {
    const cooldownEndTime = Date.now() + 60000;
    sessionStorage.setItem(`otp-cooldown-${this.userInfo?._id}`, cooldownEndTime.toString());
  }

  private clearCooldownStateFromStorage(): void {
    if (this.userInfo?._id) {
      sessionStorage.removeItem(`otp-cooldown-${this.userInfo?._id}`);
    }
  }

  private restoreCooldownStateFromStorage(): void {
    if (!this.userInfo?._id) {
      return;
    }
    const cooldownEndTimeStr = sessionStorage.getItem(`otp-cooldown-${this.userInfo?._id}`);
    if (cooldownEndTimeStr) {
      const cooldownEndTime = parseInt(cooldownEndTimeStr, 10);
      const remainingMs = cooldownEndTime - Date.now();
      if (remainingMs > 0) {
        this.countdown = Math.ceil(remainingMs / 1000);
        if (this.countdownSubscription) {
          this.countdownSubscription.unsubscribe();
          this.countdownSubscription = null;
        }
        this.countdownSubscription = timer(0, 1000).subscribe(() => {
          this.countdown = this.countdown - 1;
          if (this.countdown <= 0) {
            if (this.countdownSubscription) {
              this.countdownSubscription.unsubscribe();
              this.countdownSubscription = null;
            }
            this.clearCooldownStateFromStorage();
          }
        });
      } else {
        this.clearCooldownStateFromStorage();
      }
    }
  }

}
